import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1F1F1F] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/99ea03b7b81b29f9585eff6929d08ea6/e991eb0ea9706773f7a1b9558763ac2b.png" 
              alt="Vantex Construction LLC" 
              className="h-10 w-auto mb-6"
            />
            <div className="space-y-2 text-neutral-light-gray text-sm">
              <p>Licensed & Insured Contractor</p>
              <p>Serving Dallas-Fort Worth</p>
              <p>Residential Construction & Remodeling</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-neutral-light-gray uppercase text-sm font-semibold mb-4 tracking-wider">
              SERVICES
            </h3>
            <div className="space-y-3">
              <Link to="/services" className="block text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer">
                Concrete & Patios
              </Link>
              <Link to="/services" className="block text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer">
                Outdoor Structures
              </Link>
              <Link to="/services" className="block text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer">
                Fences & Gates
              </Link>
              <Link to="/services" className="block text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer">
                Interior Remodeling
              </Link>
            </div>
          </div>

          {/* Quick Links 2 */}
          <div>
            <h3 className="text-neutral-light-gray uppercase text-sm font-semibold mb-4 tracking-wider">
              COMPANY
            </h3>
            <div className="space-y-3">
              <Link to="/about" className="block text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer">
                About Us
              </Link>
              <Link to="/projects" className="block text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer">
                Our Projects
              </Link>
              <Link to="/quote" className="block text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer">
                Request a Quote
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-neutral-light-gray uppercase text-sm font-semibold mb-4 tracking-wider">
              CONTACT
            </h3>
            <div className="space-y-3">
              <a
                href="tel:+14692544779"
                className="flex items-center text-white hover:text-primary-red transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-primary-red text-lg mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>(469) 254-4779</span>
              </a>
              <div className="flex items-start text-white">
                <i className="ri-map-pin-fill text-primary-red text-lg mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>Dallas-Fort Worth, TX</span>
              </div>
              <a
                href="mailto:vantexconstruction@gmail.com"
                className="flex items-start text-white hover:text-primary-red transition-colors cursor-pointer"
              >
                <i className="ri-mail-fill text-primary-red text-lg mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>vantexconstruction@gmail.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Large Brand Text */}
        <div className="mb-8">
          <h2 className="text-6xl md:text-8xl lg:text-9xl font-black text-[#D4C5B0] tracking-tighter">
            VANTEX
          </h2>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-dark-gray pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-neutral-gray text-sm">
            © {currentYear} Vantex Construction LLC. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-neutral-gray hover:text-primary-red text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;